import type { UserPreferencesNotificationsContextValues } from "./user-preferences-notifications.type";

import { createContext, useContext } from "react";

export const config = {
  contextName: "UserPreferencesNotificationsContext",
  providerName: "UserPreferencesNotificationsProvider",
};

export const UserPreferencesNotificationsContext =
  createContext<UserPreferencesNotificationsContextValues | null>(null);

export const useUserPreferencesNotificationsContext = () => {
  const contextValue = useContext(UserPreferencesNotificationsContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
